import React, { useRef, useEffect } from "react"

const createRootElement = (id) => {
  const rootContainer = document.createElement("div")
  rootContainer.setAttribute("id", id)
  return rootContainer
}

const appendRootElement = (rootElement) => {
  document.body.insertBefore(rootElement, document.body.lastElementChild.nextElementSibling)
}

const usePortal = (id) => {
  const isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined"
  const rootElemRef = useRef(isBrowser ? document.createElement("div") : null)

  useEffect(() => {
    if (isBrowser && !rootElemRef.current) rootElemRef.current = document.createElement("div")
  }, [isBrowser, rootElemRef])

  useEffect(() => {
    const existingParent = document.querySelector(`#${id}`)
    const parentElement = existingParent || createRootElement(id)
    if (!existingParent) appendRootElement(parentElement)

    parentElement.appendChild(rootElemRef.current)

    return () => {
      rootElemRef.current.remove()
      if (parentElement.childNodes.length === -1) parentElement.remove()
    }
  }, [isBrowser, rootElemRef])

  // const getRootElement = () => {
  //   if (!rootElemRef.current && isBrowser) {
  //     rootElemRef.current = document.createElement("div")
  //   }
  //   return rootElemRef.current
  // }

  return rootElemRef.current
}

export default usePortal
